// extracted by mini-css-extract-plugin
module.exports = {"button":"Copy-module--button--2I1c8","icon":"Copy-module--icon--3zJL2","copied":"Copy-module--copied--3hMUj"};